import React from "react";
import { EWsrvTransform } from "../../lib/Media/util";
import { Carousel } from "../Carousel/Carousel";
import { ListingGallery } from "../Gallery/ListingGallery";
import ListingCard, { EListingCardLayouts } from "./ListingCard";
import { ListingContact } from "./ListingContact";
import ListingDetails from "./ListingDetails";
import ListingMap from "./ListingMap";
import { ListingSummary } from "./ListingSummary";
import { EListingVitalsLayout, ListingVitals } from "./ListingVitals";
import { IListingLayoutProps, RateTypes } from "./util";
import { ContactForm } from "../Forms";
import { RentalVitals } from "./RentalVitals";
import { RentalCalendar } from "./RentalCalendar";

export const RentalLayoutSingleColumn: React.FC<IListingLayoutProps> = ({
  listing,
  title,
  linkFunc,
  similar,
  agents,
  className = "",
  similarCardProps,
  similarCarouselProps,
  galleryProps,
  rentalVitalsProps,
  carouselProps,
  calendarProps,
  detailsProps,
  vitalsProps,
  contactProps,
  formProps,
  summaryProps,
  mapProps,
  rowClassName = "",
  showContactUsForm,
  contactUsFormProps,
  showAllRates = false,
  showForm,
  showRatesAndAvailabilityBlade = true,
  showRentalVideo = false
}) => {
  const rentalVitalBtnOnClick = function (props: any) {
    if (props.className?.search("view-rates-button") >= 0) {
      document.querySelector('.rates-container')?.scrollIntoView();
    }
    else if (props.className?.search("request-info-button") >= 0) {
      document.querySelector('.request-info-form')?.scrollIntoView();
      document.querySelector('.request-info-form #firstname')?.focus();
    }
  }
  const rentalVitalsLinkFunc = function (props: any) {
    return (
      <a {...props}
        onClick={() => rentalVitalBtnOnClick(props)}
      />
    )
  }

  return (
    <div className={`${className} listing-layout rental-layout-single-column`}>
      <ListingGallery
        listing={listing}
        preset={EWsrvTransform.cover3x2}
        width={1200}
        height={800}
        className="mb-3"
        {...galleryProps}
      />
      <RentalVitals
        listing={listing}
        locationIcon={false}
        composite={false}
        className="inverted mb-5 max-w-screen-xl mx-auto"
        linkFunc={rentalVitalsLinkFunc}
        {...rentalVitalsProps}
      />
      <div className={`md:grid md:grid-cols-3 md:space-x-5 ${rowClassName}`}>
        <div className="md:col-span-2 mb-3">
          {title && <h1>{title}</h1>}
          <ListingSummary listing={listing} {...summaryProps} />
        </div>
        <div className={`md:col-span-1 mb-3 request-info-form`}>
          {showForm && <ContactForm {...formProps}>
            <ListingContact
              listing={listing}
              linkFunc={linkFunc}
              {...contactProps}
            />
          </ContactForm>}
        </div>
      </div>
      {listing.videos?.[0] && showRentalVideo && (
        <div className="max-w-screen-xl mx-auto mb-10">
          <h2>Property Video</h2>
          <div className="w-full px-4">
            <iframe
              src={listing.videos[0].url}
              allowFullScreen
              allow="encrypted-media"
              className="w-full aspect-video"
            />
          </div>
        </div>
      )}
      {showRatesAndAvailabilityBlade && <div className="max-w-screen-xl mx-auto mb-10 rates-container">
        <RentalCalendar
          listing={listing}
          title="Rates & Availability"
          {...calendarProps}
        />
        {listing.cleaningFee && <p className="block italic text-xs mt-0 mb-0.5 cleaning-fee"><span className="font-bold">Cleaning fee:</span>&nbsp;{listing.cleaningFee}</p>}
        {listing.damageSecurityDeposit && <p className="block italic text-xs mt-0 mb-0.5 security-deposit"><span className="font-bold">Security deposit:</span>&nbsp;{listing.damageSecurityDeposit}</p>}
        {listing.winterComments && <p className="block italic text-xs mt-0 mb-0.5 winter-comments"><span className="font-bold">Available for Winter Season:</span>&nbsp;{listing.winterComments}</p>}
        {listing.ownerPolicies && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Owner policies:</span>&nbsp;{listing.ownerPolicies}</p>}
        {listing.checkInTime && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Check In Time:</span>&nbsp;{listing.checkInTime}</p>}
        {listing.checkOutTime && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Check Out Time:</span>&nbsp;{listing.checkOutTime}</p>}
        {listing.additionalLodgingFees && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Additional Lodging Fees:</span>&nbsp;{listing.additionalLodgingFees}</p>}

        {showAllRates && (
          <div className="mt-5 grid gap-3 grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
            {listing.rates?.map((rate) => (
              <div>
                {rate.type && <span className="block font-bold mb-1">{RateTypes[rate.type]}:</span>}
                <span>${rate.price.toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>}
      {listing.details && listing.details.length > 0 && (
        <ListingDetails
          detailGroups={listing.details}
          className="py-3"
          {...detailsProps}
        />
      )}
      {listing.location && listing.location?.lat && listing.location.lng && (
        <ListingMap listing={listing} title="Location" {...mapProps} />
      )}
      {similar && similar.length > 2 && (
        <Carousel
          title="Similar"
          slickSettings={{
            infinite: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: Math.min(3, similar.length),
            arrows: true,
          }}
          className={`slick-center-zoom max-w-screen-xl mx-auto ${similarCarouselProps?.className || ""
            }`}
          {...similarCarouselProps}
        >
          {similar.map((listing, index) => {
            return (
              <ListingCard
                layout={EListingCardLayouts.vertical}
                vitalsLayout={EListingVitalsLayout.column2Border1}
                listing={listing}
                className="max-w-[680px] mx-auto"
                maxWidthImage={680}
                key={index}
                linkFunc={linkFunc}
                {...similarCardProps}
              />
            );
          })}
        </Carousel>
      )}
      {showContactUsForm && <ContactForm {...contactUsFormProps} />}
    </div>
  );
};
